import React from 'react';
import { FormikProps } from 'formik';
import { SectionTitle } from '@/components/ui/section-title';
import { ActionButton, Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CheckIcon, PencilIcon, TrashIcon, Plus, FilePen } from 'lucide-react';
import { Seguro } from '@/types/Seguro';
import { Endosso } from '@/types/Endosso';
import { FormikSelect } from '@/components/ui/select';
import { getTipoEndossoLabel, TipoEndossoValues } from '@/types/enum/TipoEndosso';
import { FormikTextArea } from '@/components/ui/textarea';

type SeguroEndossoSectionParams = {
    formikProps: FormikProps<Seguro>;
    adicionar: () => void;
    salvar: () => void;
    alterar: (index: number) => void;
    remover: (index: number) => void;
    loading: boolean;
    indexEditando: number|undefined;
}

const SeguroEndossoSection: React.FC<SeguroEndossoSectionParams> = ({
    adicionar, alterar, remover, salvar, formikProps, loading, indexEditando
}) => {
    return (
        <>
            <SectionTitle hasButton icon={<FilePen />} cor="bg-amber-500/10 text-amber-600 dark:text-amber-400">
                Endosso
                <Button type="button" variant="outline" size="sm" className="disabled:hidden" onClick={adicionar}><Plus className="mr-1.5 h-4 w-4" /> Adicionar</Button>
            </SectionTitle>
            {formikProps.values.endossos && formikProps.values.endossos?.length > 0 && (                                
                <Card className='w-full overflow-hidden shadow-none'>
                    <Table className="tabela-empilhada">
                        <TableHeader>
                            <TableRow>
                                <TableHead>Tipo</TableHead>
                                <TableHead>Observação</TableHead>
                                <TableHead></TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {formikProps.values.endossos.map((item, index) => (
                                <TableRow key={`endosso-${index}`}>
                                    <TableCell data-label="Tipo">
                                        {indexEditando===index ? (
                                            <FormikSelect 
                                                name={`endossos.${index}.tipo`}
                                                value={formikProps.values.endossos![index].tipo}
                                                itens={TipoEndossoValues} 
                                                getOptionLabel={value => value.descricao}
                                                getOptionValue={value => value.codigo}
                                            />    
                                        ): (
                                            <>                                        
                                                {getTipoEndossoLabel(item.tipo)}
                                                {formikProps.errors.endossos && formikProps.errors.endossos[index] && (formikProps.errors.endossos[index] as unknown as Endosso).tipo &&(
                                                    <div className='mt-1 text-xs font-medium text-destructive'>{`${(formikProps.errors.endossos[index] as unknown as Endosso).tipo}`}</div>
                                                )}                                                                
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell data-label="Observação">
                                        {indexEditando===index ? (
                                            <FormikTextArea
                                                name={`endossos.${index}.observacaoEndosso`}
                                                value={formikProps.values.endossos![index].observacaoEndosso}
                                                />
                                        ): (
                                            <>
                                                {item.observacaoEndosso}
                                                {formikProps.errors.endossos && formikProps.errors.endossos[index] && (formikProps.errors.endossos[index] as unknown as Endosso).observacaoEndosso &&(
                                                    <div className='mt-1 text-xs font-medium text-destructive'>{`${(formikProps.errors.endossos[index] as unknown as Endosso).observacaoEndosso}`}</div>
                                                )}                                                                
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell className='text-right'>
                                        {index === indexEditando ? (
                                            <>
                                            <ActionButton icon={<CheckIcon className="h-3.5 w-3.5" />} label='Adicionar' onClick={() => salvar()} />
                                            </>
                                        ) : (
                                            <>
                                            <ActionButton icon={<PencilIcon className="h-3.5 w-3.5" />} label='Editar' onClick={() => alterar(index)} />
                                            <ActionButton variant='destructive' icon={<TrashIcon className="h-3.5 w-3.5" />} label='Remover' onClick={() => remover(index)} />
                                            </>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Card>
            )}                              
        </>
    );
}

export default SeguroEndossoSection;